const categories = [
  {
    name: 'Danger',
    value: 'bg-danger'
  },
  {
    name: 'Success',
    value: 'bg-success'
  },
  {
    name: 'Primary',
    value: 'bg-primary'
  },
  {
    name: 'Info',
    value: 'bg-info'
  },
  {
    name: 'Dark',
    value: 'bg-dark'
  },
  {
    name: 'Warning',
    value: 'bg-warning'
  },
  {
    name: 'Light',
    value: 'bg-light'
  },
];

export { categories };
